export default __webpack_public_path__ + "static/media/14.51338cfb.png";